import { createContext, useContext } from 'react'
import SearchRegionNodeTransport from '../transports/search-region-node-transport'

const SearchRegionNodeContext = createContext<SearchRegionNodeTransport | null>(null)

export const SearchRegionNodeProvider = SearchRegionNodeContext.Provider

export const useSearchRegionNode = (): SearchRegionNodeTransport | null => useContext(SearchRegionNodeContext)

export default SearchRegionNodeContext
